import React from "react";
import Card from "components/card";

const ThemedSummaryCard = ({
  title,
  displayCount = 0,
  badgeText,
  description,
  icon,
  colorTheme, 
}) => {
  return (
    <Card extra="rounded-xl border border-l-4 border-l-blue-500 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex flex-row items-center justify-between px-6 pt-6 pb-2">
        <h4 className="text-[13px] uppercase tracking-wide text-muted-foreground leading-tight">
          {title}
        </h4>
        {icon && <div className={`p-2 bg-text ${colorTheme}`}>{icon}</div>}
      </div>

      <div className="px-6 [&:last-child]:pb-6">
        <div className="flex items-baseline gap-2">
          <div className="text-[32px] font-semibold text-slate-900 leading-none">
            {displayCount}
          </div>
          {badgeText && (
            <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 gap-1 text-[10px] bg-blue-50 text-blue-700 border-blue-200 leading-none h-5">
              {badgeText}
            </span>
          )}
        </div>
        {description && (
          <p className="text-[12px] text-muted-foreground mt-2 leading-tight">
            {description}
          </p>
        )}
      </div>
    </Card>
  );
};

export default ThemedSummaryCard;
